module.exports = __webpack_public_path__ + "img/icon_02.1215699d.svg";